import React, { useState } from 'react';
import {
	Alerts,
	Button,
	Slider,
	Toast as notificationPopUp,
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from '../ApiKeys.module.scss';
import ApiKeysCreateForm from '../../containers/ApiKeysCreateForm';
import { IAPIKeys } from '../../../../../interface';
import APIDetails from '../APIDetails';

export type MapStatePropsType = {
	sidebarVisibility: any;
};

export type DispatchPropsType = {
	onClose: () => void;
	OnSuccessCallSlider: (data: any) => void;
};

const APIKeyCreate: React.FC<MapStatePropsType & DispatchPropsType> = ({
	onClose,
	sidebarVisibility
}) => {
	const [createDisable, setCreateDisable] = useState(false);
	const [createSave, setCreateSave] = useState(false);
	const [sideModalSuccess, setSideModalSuccess] = useState(false);
	const [savedObj, setSavedObj] = useState({} as IAPIKeys);
	const [downloadExpired, setDownloadExpired] = useState(false);
	const { t } = useTranslation();
	const getFooter = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button
					type="primary"
					onClick={() => setCreateSave(true)}
					disabled={createDisable}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	};
	const timeoutFor15Min = () => {
		setTimeout(() => {
			setDownloadExpired(true);
		}, 900000);
	};
	const generateSuccessContent = () => {
		return (
			<>
				<Alerts
					content={t('apiKeyAlert')}
					containerClassName={Styles.alertStyle}
					type="info"
				/>
				<APIDetails
					host={savedObj?.host}
					sid={savedObj?.sid}
					apiKey={savedObj?.api_key_full}
				></APIDetails>
			</>
		);
	};
	const getFooterForSuccess = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainerSuccess}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button
					type="primary"
					onClick={() => {
						downloadExpired
							? notificationPopUp(t('downloadExpired'), 'error')
							: window.open(savedObj?.s3_link, '_self');
					}}
				>
					{t('mainDownload')}
				</Button>
			</div>
		);
	};
	// const handleDownload = async () => {
	// 	await onDownload({ id: savedObj?.id });
	// 	// onClose();
	// };
	return (
		<Slider
			containerId="root-modal"
			onClose={onClose}
			visibility={sidebarVisibility}
			footer={getFooter()}
			title={t('createAPIKey')}
		>
			<div className={Styles.container}>
				<ApiKeysCreateForm
					onCancel={() => onClose()}
					save={createSave}
					onDisable={(val: boolean) => {
						setCreateDisable(val);
					}}
					onResetSave={() => setCreateSave(false)}
					onSuccess={(obj: any) => {
						setSavedObj(obj);
						setSideModalSuccess(true);
						timeoutFor15Min();
					}}
				/>
			</div>

			<Slider
				containerId="root-modal"
				onClose={() => {
					onClose();
				}}
				visibility={sideModalSuccess}
				footer={getFooterForSuccess()}
				title={t('createAPIKeySuccess')}
				dialog={true}
			>
				{generateSuccessContent()}
			</Slider>
		</Slider>
	);
};

export default APIKeyCreate;
